module.exports = __webpack_public_path__ + "img/bane.82d43593.png";